// extracted by mini-css-extract-plugin
export var cartSummary = "cart-module--cartSummary--646b4";
export var checkoutBtn = "cart-module--checkoutBtn--ac720";
export var checkoutInfo = "cart-module--checkoutInfo--89975";
export var container = "cart-module--container--fe08d";
export var heading = "cart-module--heading--15cbf";